import { useState } from 'react';
import TreeView from '@mui/lab/TreeView';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import TreeItem from '@mui/lab/TreeItem';
import FolderIcon from '@mui/icons-material/Folder';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { WrapperButtons } from '../styles';
import { ViewIcon, ViewSection } from './styles';

const ViewTree = () => {
  const [enabled, setEnabled] = useState(true);
  const [archieve, setArchieve] = useState(false);

  const enabledButton = (clickEnabled) => {
    setEnabled(clickEnabled);
  };

  const viewArchive = () => {
    setArchieve(true);
  };

  const undoArchieve = () => {
    setArchieve(false);
  };

  return (
    <>
      {archieve ? (
        <>
          <ViewSection>
            <ViewIcon>
              <PictureAsPdfIcon style={{ fontSize: '6.4rem' }} />
            </ViewIcon>
            <div className="section-text">
              <strong>Fecha de creación:</strong> 12-02-2022 10:00:00
              <strong>Autor: </strong>Saúl Mauricio Franco Rentería
              <strong>Peso:</strong>15kb
              <strong>Status:</strong> En revisión
            </div>
          </ViewSection>
        </>
      ) : (
        <TreeView
          aria-label="file system navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{ height: 240, flexGrow: 1, maxWidth: '95%', overflowY: 'auto' }}
        >
          <TreeItem nodeId="0" label="archivo.xls" icon={<TextSnippetIcon />} onClick={() => enabledButton(false)} />
          <TreeItem nodeId="1" label="Carpeta 1" icon={<FolderIcon />} onClick={() => enabledButton(true)}>
            <TreeItem nodeId="2" label="data_example.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="3" label="data_example.xls" icon={<TextSnippetIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="4" label="data_example.word" icon={<TextSnippetIcon />} onClick={() => enabledButton(false)} />
          </TreeItem>
          <TreeItem nodeId="5" label="Carpeta 2" icon={<FolderIcon />} onClick={() => enabledButton(true)}>
            <TreeItem nodeId="10" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="6" label="Carpeta 5" icon={<FolderIcon />} onClick={() => enabledButton(true)}>
              <TreeItem nodeId="8" label="arhivo.xls" icon={<TextSnippetIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="11" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="12" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="13" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
            </TreeItem>
          </TreeItem>
          <TreeItem nodeId="14" label="Carpeta 7" icon={<FolderIcon />} onClick={() => enabledButton(true)}>
            <TreeItem nodeId="15" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
            <TreeItem nodeId="16" label="Carpeta 10" icon={<FolderIcon />} onClick={() => enabledButton(true)}>
              <TreeItem nodeId="17" label="arhivo.xls" icon={<TextSnippetIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="18" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="19" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
              <TreeItem nodeId="20" label="archivo.pdf" icon={<PictureAsPdfIcon />} onClick={() => enabledButton(false)} />
            </TreeItem>
          </TreeItem>
        </TreeView>
      )}

      <WrapperButtons>
        {archieve ? (
          <>
            <Button
              variant="contained"
              color="error"
              disabled={enabled}
              style={{ marginRight: '15px', width: '100%' }}
              onClick={() => undoArchieve()}
            >
              Regresar
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={enabled}
              style={{ marginRight: '15px', width: '100%' }}
              // onClick={() => viewArchive()}
            >
              Descargar Archivo
            </Button>
          </>
        ) : (
          <>
            <Button variant="contained" color="primary" disabled={enabled} style={{ marginRight: '15px', width: '100%' }}>
              Descargar
            </Button>
            <Button
              variant="contained"
              color="success"
              disabled={enabled}
              style={{ marginRight: '15px', width: '100%' }}
              onClick={() => viewArchive()}
            >
              Ver archivo
            </Button>
          </>
        )}
      </WrapperButtons>
    </>
  );
};

export default ViewTree;
